import 'css-chunksrc/client/pages/zonePage/reportsPage/loader/reportLoader/styles.scss';export default {
  "report": "_report_1gdki_1",
  "nameBox": "_nameBox_1gdki_15",
  "projectName": "_projectName_1gdki_23",
  "separator": "_separator_1gdki_29",
  "reportName": "_reportName_1gdki_34",
  "row": "_row_1gdki_40",
  "label": "_label_1gdki_47",
  "author": "_author_1gdki_54",
  "authorAvatar": "_authorAvatar_1gdki_63",
  "authorName": "_authorName_1gdki_74",
  "text": "_text_1gdki_80",
  "indicators": "_indicators_1gdki_85"
};